export { default as ROASlider } from './slider'



// WEBPACK FOOTER //
// ./src/components/images/slider/index.js